import { Field } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core/WorksheetEquipment';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { SieveSetDimensionsFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { ISieveSetDimensions } from 'Data/ViewModels/Equipment/types';
import { Guid } from 'Lib/Guid';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';

// This section is copied from the ASTM C136 worksheet
let PortionSievingEquipmentSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const sieveSetDimensions: ISieveSetDimensions = useSelector(
    createWorksheetSelector!('Equipment.SieveSetDimensions'),
    deepEquals
  );
  const sieveSetImportMismatch = useSelector(createWorksheetSelector!('Equipment.SieveSetImportMismatch')) as boolean;
  const sieveSetId = useSelector(createWorksheetSelector!('Equipment.SieveSet.Id')) as Guid;

  return (
    <NamePrefixModifier appendNamePrefix="Equipment">
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Balance" />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<WorksheetEquipmentDropdown />}
          name="SieveSet"
          equipmentType="sieve-set"
          importedAdditionalData={{
            Dimensions: sieveSetDimensions,
            Mismatch: sieveSetImportMismatch,
          }}
          importModel={{ Id: sieveSetId }}
        />
        <SieveSetDimensionsFieldSet />
      </ListFieldSection>
    </NamePrefixModifier>
  );
};

PortionSievingEquipmentSection = withInjectedProps(PortionSievingEquipmentSection);

export { PortionSievingEquipmentSection };
export default PortionSievingEquipmentSection;
